import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectCollisionDamageStarrStep = (state) => state.get('collisionDamageStarrStep');

const makeSelectCollisionDamageStarrStep = () => createSelector(
  selectCollisionDamageStarrStep,
  (stepCollisionDamageStarrState) => ({
    areYouClaimingForRentalCarDamage: mapWithDefault(
      stepCollisionDamageStarrState,
      () => stepCollisionDamageStarrState.getIn(['form', 'areYouClaimingForRentalCarDamage']),
      ''
    ),
    companyNameForOther: mapWithDefault(
      stepCollisionDamageStarrState,
      () => stepCollisionDamageStarrState.getIn(['form', 'companyNameForOther']),
      ''
    ),
    typeOfPolicyForOther: mapWithDefault(
      stepCollisionDamageStarrState,
      () => stepCollisionDamageStarrState.getIn(['form', 'typeOfPolicyForOther']),
      ''
    ),
    policyForOther: mapWithDefault(
      stepCollisionDamageStarrState,
      () => stepCollisionDamageStarrState.getIn(['form', 'policyForOther']),
      ''
    ),
    nameOfRentalCarCompany: mapWithDefault(
      stepCollisionDamageStarrState,
      () => stepCollisionDamageStarrState.getIn(['form', 'nameOfRentalCarCompany']),
      ''
    ),
    expenseDescriptionOfItems: mapWithDefault(stepCollisionDamageStarrState, () => stepCollisionDamageStarrState.getIn(['form', 'expenseDescriptionOfItems']) && stepCollisionDamageStarrState.getIn(['form', 'expenseDescriptionOfItems']).toJS(), ''),
  })
);

const makeSelectCollisionDamageStarrStepErrors = () =>
  createSelector(selectCollisionDamageStarrStep, (state) => state.get('errors'));

export {
  makeSelectCollisionDamageStarrStep,
  makeSelectCollisionDamageStarrStepErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.Starr.StepCollisionDamage/selectors.js